/* MOEBE GARAN phase 1. Native dialog, no dependencies or checkout changes. */
(() => {
  'use strict';
  if (!window.customElements || customElements.get('moebe-guarantee-notice')) return;
  class MoebeGuaranteeNotice extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected) this.initialise(); });
    }
    initialise() {
      if (this.events) return;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-notice-open]');
      if (!this.dialog || !this.trigger || typeof this.dialog.showModal !== 'function') return;
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      this.trigger.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.open();
      }, options);
      this.trigger.addEventListener('keydown', event => {
        if (event.key === ' ') { event.preventDefault(); this.open(); }
      }, options);
      this.querySelector('[data-notice-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('cancel', event => {
        event.preventDefault();
        this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.restorePage(true), options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const stops = [...this.dialog.querySelectorAll('a[href], button:not([disabled]), summary, [tabindex="0"]')].filter(element => {
          const closedDetails = element.closest('details:not([open])');
          return element.getClientRects().length && (!closedDetails || element === closedDetails.querySelector('summary'));
        });
        const first = stops[0], last = stops[stops.length - 1];
        if (!first) { event.preventDefault(); return; }
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      }, options);
      const outside = event => {
        const r = this.dialog.getBoundingClientRect();
        return event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom;
      };
      this.dialog.addEventListener('pointerdown', event => { this.backdropStart = outside(event); }, options);
      this.dialog.addEventListener('click', event => {
        if (this.backdropStart && event.target === this.dialog && outside(event)) this.dialog.close();
        this.backdropStart = false;
      }, options);
      this.querySelector('[data-notice-zoom]').addEventListener('click', () => {
        const artwork = this.querySelector('[data-notice-artwork]');
        const zoom = this.querySelector('[data-notice-zoom]');
        const enlarged = artwork.classList.toggle('is-enlarged');
        zoom.setAttribute('aria-pressed', String(enlarged));
        zoom.textContent = enlarged ? zoom.dataset.labelFit : zoom.dataset.labelEnlarge;
      }, options);
      this.querySelector('[data-notice-image]').addEventListener('error', () => {
        this.querySelector('[data-notice-error]').hidden = false;
        this.querySelector('[data-notice-transcript]').open = true;
      }, options);
    }
    open() {
      if (this.dialog.open) return;
      const image = this.querySelector('[data-notice-image]');
      if (!image.getAttribute('src')) image.src = image.dataset.src;
      const style = document.body.style;
      const properties = ['position', 'top', 'left', 'width', 'overflow', 'padding-right', 'box-sizing'];
      this.pageState = {
        x: window.scrollX, y: window.scrollY,
        properties: properties.map(name => [name, style.getPropertyValue(name), style.getPropertyPriority(name)])
      };
      const gap = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
      const padding = parseFloat(getComputedStyle(document.body).paddingRight) || 0;
      style.setProperty('position', 'fixed');
      style.setProperty('top', `${-this.pageState.y}px`);
      style.setProperty('left', `${-this.pageState.x}px`);
      style.setProperty('width', '100%');
      style.setProperty('overflow', 'hidden');
      style.setProperty('box-sizing', 'border-box');
      style.setProperty('padding-right', `${padding + gap}px`);
      try {
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
        this.querySelector('[data-notice-body]').scrollTop = 0;
        this.querySelector('[data-notice-close]').focus({preventScroll: true});
      } catch (error) {
        this.restorePage(true);
        console.warn('MOEBE: the legal guarantee notice could not open.', error);
      }
    }
    restorePage(returnFocus) {
      const state = this.pageState;
      if (!state) return;
      this.pageState = null;
      for (const [name, value, priority] of state.properties) {
        if (value) document.body.style.setProperty(name, value, priority);
        else document.body.style.removeProperty(name);
      }
      this.trigger.setAttribute('aria-expanded', 'false');
      const rootStyle = document.documentElement.style;
      const behaviour = rootStyle.getPropertyValue('scroll-behavior');
      const priority = rootStyle.getPropertyPriority('scroll-behavior');
      rootStyle.setProperty('scroll-behavior', 'auto', 'important');
      window.scrollTo(state.x, state.y);
      if (returnFocus && this.trigger.isConnected) this.trigger.focus({preventScroll: true});
      if (behaviour) rootStyle.setProperty('scroll-behavior', behaviour, priority);
      else rootStyle.removeProperty('scroll-behavior');
    }
    disconnectedCallback() {
      this.restorePage(false);
      if (this.events) this.events.abort();
      this.events = null;
    }
  }
  customElements.define('moebe-guarantee-notice', MoebeGuaranteeNotice);
})();
